import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import XIcon from '@mui/icons-material/X';
import EmailIcon from '@mui/icons-material/Email';
import AltImage from '../user-alt-1.svg';

export default function ContactCard(props) {
    const item = props.item;
    // console.log(item);
    if (item) {
        return (
            <Card sx={{ maxWidth: 345 }}>
                <CardActionArea>
                    <CardMedia
                        component="img"
                        height="300"
                        image={item['image'] ? item['image'] : AltImage}
                        alt={item['name']}
                        />
                        <CardContent>
                        <Typography gutterBottom variant="h5" component="div" style={{textAlign: 'left'}}>
                            {item['name']}
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary' }}  style={{textAlign: 'left'}}>
                            {item['title']}
                        </Typography>
                        <hr />
                        <a href={item['twitter']} target='_blank' style={{padding: '10px'}}>
                            <XIcon />
                        </a>
                        <a href={`mailto:${item['email']}`} style={{padding: '10px'}}>
                            <EmailIcon />
                        </a>
                    </CardContent>
                </CardActionArea>
            </Card>
        );
    } else {
        return (
            <div></div>
        )
    }
}